import clsx from "clsx";
import { MessageSourceType } from "utils/enum";

import Badge from "components/Badge";
import ChatMessageHeader from "./ChatMessageHeader";
import styles from "./styles.module.scss";
import { ChatMessageProps, MessageReplyProps } from "./types";

export default function ChatMessage({
	title,
	category,
	service,
	message,
	children,
	timestamp,
	messageSource,
	profilePic,
	showHeader = true,
	messageSender
}: ChatMessageProps) {
	const isUserMessage = messageSource === MessageSourceType.PARTNER;
	const datetime = timestamp ? new Date(timestamp) : undefined;
	const dateFormatted = datetime ? datetime.toLocaleDateString("pt-BR") : "";
	const timeFormatted = datetime ? datetime.toLocaleTimeString("pt-BR") : "";

	const datetimeFormatted = dateFormatted
		? `${dateFormatted} ${timeFormatted}`
		: "";

	return (
		<div>
			{showHeader && (
				<ChatMessageHeader
					messageSource={messageSource}
					profilePic={profilePic}
					timestamp={datetimeFormatted}
					messageSender={messageSender}
				/>
			)}

			<div
				className={clsx({
					[styles.userMessageContainer]: isUserMessage,
					[styles.messageContainer]: !isUserMessage
				})}
			>
				{typeof title === "string" && (
					<div className="heading_md">{title || ""}</div>
				)}
				{typeof category === "string" && (
					<Badge type="category" label={category || ""} />
				)}
				<div className="heading_sm">{service}</div>
				<div className={clsx(["body text-neutral-500", styles.messageContent])}>
					{message || children}
				</div>
			</div>
		</div>
	);
}

export function MessageReply({ children, profilePic }: MessageReplyProps) {
	return (
		<div>
			<ChatMessageHeader
				messageSource={MessageSourceType.PARTNER}
				profilePic={profilePic}
			/>
			{Array.isArray(children) ? (
				children.map((child, index) =>
					typeof child !== "boolean" ? (
						<div
							key={`reply-${index}`}
							className={styles.userMessageContainerReply}
						>
							{child}
						</div>
					) : null
				)
			) : (
				<div className={styles.userMessageContainerReply}>{children}</div>
			)}
		</div>
	);
}
